module.exports = __webpack_public_path__ + "static/media/mic-bg.fc0e7fb3.png";